export default __webpack_public_path__ + "images/0xdac17f958d2ee523a2206206994597c13d831ec7.png";